<template>
  <div id="app_settings">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />

    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex pa-4>
        <v-card id="app_height">
          <v-layout pt-8 wrap justify-center>
            <v-flex xs12 sm2 md1 text-center>
              <v-btn x-large icon router-link to="/Settings">
                <v-img src="../../assets/icons/back.png" aspect-ratio="1" contain height="400">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-btn>
            </v-flex>
            <v-flex xs12 sm8 md10 text-center>
              <span style="font-size:28px;font-weight:500;color:#464646">Bank</span>
            </v-flex>
            <v-flex xs12 sm2 md1></v-flex>
          </v-layout>
          <v-layout wrap justify-center px-2>
            <v-flex xs12 sm12 md8>
              <v-layout v-if="!showBankAdd" wrap justify-center>
                <v-flex xs12 sm12 md4 py-4 text-center>
                  <v-card @click="showBankAdd=true">
                    <v-layout>
                      <v-flex pa-4>
                        <v-icon>mdi-plus-circle-outline</v-icon>&nbsp;
                        <span style="font-size:14px;font-weight:500">Add New</span>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout v-if="showBankAdd" wrap justify-center>
                <v-flex xs12 sm12 md6 py-4 text-center>
                  <v-card>
                    <v-layout wrap justify-start>
                      <v-flex md12 pa-4>
                        <v-text-field
                          ref="bank"
                          :rules="[rules.required]"
                          v-model="bank"
                          label="Bank"
                          color="#26af82"
                          required
                        ></v-text-field>
                        <v-text-field
                          ref="accountHolder"
                          :rules="[rules.required]"
                          v-model="accountHolder"
                          label="Account Holder"
                          color="#26af82"
                          required
                        ></v-text-field>
                        <v-text-field
                          ref="accountNo"
                          :rules="[rules.required]"
                          v-model="accountNo"
                          label="Account Number"
                          color="#26af82"
                          required
                        ></v-text-field>
                        <v-layout wrap justify-space-between>
                          <v-flex xs12 sm12 md6 pr-2>
                            <v-text-field
                              ref="bankCode"
                              :rules="[rules.required]"
                              v-model="bankCode"
                              label="Bank Code"
                              color="#26af82"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <v-text-field
                              ref="branch"
                              :rules="[rules.required]"
                              v-model="branch"
                              label="Branch"
                              color="#26af82"
                              required
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap justify-space-around>
                          <v-flex pa-2 xs12 sm12 md5>
                            <v-btn
                              small
                              :ripple="false"
                              class="text-capitalize"
                              dark
                              color="#00A972"
                              block
                              @click="submit"
                            >Submit</v-btn>
                          </v-flex>
                          <v-flex pa-2 xs12 sm12 md5>
                            <v-btn
                              small
                              :ripple="false"
                              class="text-capitalize"
                              dark
                              color="red"
                              block
                              @click="disableEdit"
                            >Cancel</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout v-else wrap justify-center>
                <v-flex xs12 sm12 md5 py-4 px-2 text-left v-for="(item,i) in banks" :key="i">
                  <v-card outlined>
                    <v-layout wrap>
                      <v-flex xs6 sm6 md6 px-4 py-2>
                        <span style="font-size:14px;font-weight:500">Bank</span>
                      </v-flex>
                      <v-flex xs6 sm6 md6 px-4 py-2>
                        <span style="font-size:14px;font-weight:500">{{item.Bank}}</span>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout wrap>
                      <v-flex xs6 sm6 md6 px-4 py-2>
                        <span style="font-size:14px;font-weight:500">Account Holder</span>
                      </v-flex>
                      <v-flex xs6 sm6 md6 px-4 py-2>
                        <span style="font-size:14px;font-weight:500">{{item.AccountHolder}}</span>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout wrap>
                      <v-flex xs6 sm6 md6 px-4 py-2>
                        <span style="font-size:14px;font-weight:500">Account Number</span>
                      </v-flex>
                      <v-flex xs6 sm6 md6 px-4 py-2>
                        <span style="font-size:14px;font-weight:500">{{item.AccountNumber}}</span>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout wrap>
                      <v-flex xs6 sm6 md6 px-4 py-2>
                        <span style="font-size:14px;font-weight:500">Bank Code</span>
                      </v-flex>
                      <v-flex xs6 sm6 md6 px-4 py-2>
                        <span style="font-size:14px;font-weight:500">{{item.BankCode}}</span>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout wrap>
                      <v-flex xs6 sm6 md6 px-4 py-2>
                        <span style="font-size:14px;font-weight:500">Branch</span>
                      </v-flex>
                      <v-flex xs6 sm6 md6 px-4 py-2>
                        <span style="font-size:14px;font-weight:500">{{item.Branch}}</span>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout wrap text-center>
                      <v-flex xs6 sm6 md6 pa-4>
                        <v-btn
                          text
                          small
                          :ripple="false"
                          class="text-capitalize"
                          dark
                          color="#00A972"
                          block
                          @click="enableEdit(item)"
                        >Edit</v-btn>
                      </v-flex>
                      <v-flex xs6 sm6 md6 pa-4>
                        <v-btn
                          text
                          small
                          :ripple="false"
                          class="text-capitalize"
                          dark
                          color="red"
                          block
                          @click="deleteBank(item)"
                        >Delete</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      trash: null,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      ServerError: false,
      showBankAdd: false,
      banks: [],

      bank: null,
      accountHolder: null,
      accountNo: null,
      bankCode: null,
      branch: null,
      bankRoute: "/bank/add",
      bankId: null,
      rules: {
        required: value => !!value || "Required",
        min: value => (!!value && value.length >= 8) || "Min 8 characters"
      }
    };
  },
  computed: {
    form() {
      return {
        bank: this.bank,
        accountHolder: this.accountHolder,
        accountNo: this.accountNo,
        bankCode: this.bankCode,
        branch: this.branch
      };
    }
  },
  mounted() {
    this.getData();
  },
  watch: {},
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/bank/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.banks = response.data.data;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    submit() {
      this.formHasErrors = false;

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;
        this.$refs[f].validate(true);
      });
      if (!this.formHasErrors) {
        this.addBank();
      } else {
        this.msg = "Please Validate Input";
        this.showsnackbar = true;
      }
    },
    addBank() {
      this.appLoading = true;
      var bankData = {};
      bankData["id"] = this.bankId;
      bankData["Bank"] = this.bank;
      bankData["AccountHolder"] = this.accountHolder;
      bankData["AccountNumber"] = this.accountNo;
      bankData["BankCode"] = this.bankCode;
      bankData["Branch"] = this.branch;
      axios({
        method: "POST",
        url: this.bankRoute,
        data: bankData,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.msg = response.data.msg;
          this.showsnackbar = true;
          this.showBankAdd = false;
          this.bankId = null;
          this.bank = null;
          this.accountHolder = null;
          this.accountNo = null;
          this.bankCode = null;
          this.branch = null;
          this.getData();
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    enableEdit(item) {
      this.showBankAdd = true;
      this.bankId = item._id;
      this.bank = item.Bank;
      this.accountHolder = item.AccountHolder;
      this.accountNo = item.AccountNumber;
      this.bankCode = item.BankCode;
      this.branch = item.Branch;
      this.bankRoute = "/bank/edit";
    },
    disableEdit() {
      this.bankRoute = "/bank/add";
      this.showBankAdd = false;
      this.bankId = null;
      this.bank = null;
      this.accountHolder = null;
      this.accountNo = null;
      this.bankCode = null;
      this.branch = null;
    },
    deleteBank(item) {
      this.appLoading = true;
      var bankData = {};
      bankData["id"] = item._id;
      axios({
        method: "POST",
        url: "/bank/remove",
        data: bankData,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.msg = response.data.msg;
          this.showsnackbar = true;
          this.showBankAdd = false;
          this.getData();
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
<style scoped>
#app_settings {
  background-image: url("../../assets/home_header.png");
  /* background-color: #26af82; */
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}

#app_height {
  min-height: 80vh;
}
.curpswd.v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
</style>